import Vue from "vue";
import Vuex from "vuex";

import UserModule from './stores/user';
import HealthDataModule from './stores/health-data';
import NotificationsModule from './stores/notifications';
import LoadingModule from './stores/loading'
import SelectionModule from './stores/selection'

// Use Vuex
Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    user: UserModule,
    healthData: HealthDataModule,
    notifications: NotificationsModule,
    loading: LoadingModule,
    selection: SelectionModule,
  }
});
